const rankingItems = [
  { rank: 1, title: '时光旅人', tag: '爱情科幻', rating: '9.3', hot: '本周最热', medal: 'bg-accent-500' },
  { rank: 2, title: '星际边界', tag: '科幻巨制', rating: '9.1', hot: '口碑飙升', medal: 'bg-secondary-400' },
  { rank: 3, title: '深海奇缘', tag: '动画奇幻', rating: '9.0', hot: '新片入榜', medal: 'bg-secondary-600' },
  { rank: 4, title: '极地使命', tag: '冒险剧情', rating: '8.9', hot: '持续热映', medal: '' },
  { rank: 5, title: '暗夜追踪', tag: '悬疑动作', rating: '8.7', hot: '新片入榜', medal: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-2xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">热播榜单</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">菲菲影院本周最受欢迎电影排行榜</p>
        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${
                item.rank <= 3 ? 'bg-primary-500 text-white' : 'bg-background-300 text-foreground-600'
              }`}>
                {item.rank}
              </span>
              {item.medal && (
                <span className={`w-6 h-6 flex items-center justify-center rounded-full ${item.medal} text-white text-[10px] shrink-0`}>
                  <i className={`${item.rank === 1 ? 'ri-vip-crown-line' : item.rank === 2 ? 'ri-medal-line' : 'ri-award-line'} text-xs`}></i>
                </span>
              )}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-900 whitespace-nowrap">{item.title}</span>
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="flex items-center gap-1 text-accent-500 shrink-0">
                <i className="ri-star-fill text-xs"></i>
                <span className="text-sm font-medium">{item.rating}</span>
              </div>
              <span className="text-xs text-foreground-500 whitespace-nowrap hidden sm:block">{item.hot}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}